module.exports = __webpack_public_path__ + "static/media/close.77ff0aa0.svg";